package fr.manyverse.app.domain.model

import manyverse.shared.generated.resources.Res
import manyverse.shared.generated.resources.crochet_default
import manyverse.shared.generated.resources.lock_default
import org.jetbrains.compose.resources.DrawableResource

/**
 * Returns the lockpicking lock and pick images.
 */
fun getLockpickingImages(): Pair<DrawableResource, DrawableResource> {
    return Res.drawable.lock_default to Res.drawable.crochet_default
}
